import { type ComponentProps } from 'react';
import { cn } from '../../lib/utils';

/** Vertical stack of form inputs: full width on small screens, `300px` from `sm` up. Override with `className`. */
export const SimpleStack = ({ className, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      className={cn('flex w-full flex-col gap-4 sm:w-[300px]', className)}
      {...props}
    />
  );
};
